module.exports = __webpack_public_path__ + "static/neighbourhood-no-bg-df579cf1ebed9281fc571df1109c8b22.png";